import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export type FamilyBeacon = {
  id: string; status: "active"; activatedBy: string; activatedByName: string;
  latitude: number; longitude: number; accuracy: number; activatedAtMs: number; expiresAtMs: number;
  acknowledgedUids: string[]; phoneNumber?: string;
};

const getBeacon = httpsCallable<{ householdId: string }, { beacon: FamilyBeacon | null }>(functions, "getFamilyBeacon");
const activateBeacon = httpsCallable<{ householdId: string; location: { latitude: number; longitude: number; accuracy: number } }, { beacon: FamilyBeacon }>(functions, "activateFamilyBeacon");
const acknowledgeBeacon = httpsCallable<{ householdId: string; beaconId: string }, { beacon: FamilyBeacon | null }>(functions, "acknowledgeFamilyBeacon");
const cancelBeacon = httpsCallable<{ householdId: string; beaconId: string }, { cancelled: boolean }>(functions, "cancelFamilyBeacon");

export async function getFamilyBeacon(householdId: string) { return (await getBeacon({ householdId })).data.beacon; }
export async function activateFamilyBeacon(householdId: string, location: GeolocationCoordinates) {
  return (await activateBeacon({ householdId, location: { latitude: location.latitude, longitude: location.longitude, accuracy: location.accuracy } })).data.beacon;
}
export async function acknowledgeFamilyBeacon(householdId: string, beaconId: string) { return (await acknowledgeBeacon({ householdId, beaconId })).data.beacon; }
export async function cancelFamilyBeacon(householdId: string, beaconId: string) { return (await cancelBeacon({ householdId, beaconId })).data.cancelled; }
